import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-arrow-down-icon',
  templateUrl: './arrow-down-icon.component.html',
})
export class ArrowDownIconComponent {
}
